/* global document */
(function () {
  'use strict';

  function MultiVideoPlayer() {
    return {
      templateUrl: 'video/video-player/multi-video-player.tpl.html',
      controller: 'MultiVideoPlayerCtrl',
      controllerAs: 'multiVideoPlayer',
      restrict: 'E',
      scope: {
        idVideo: '@',
        alertaId: '@',
        snapshotId: '@',
        latitude: '@',
        longitude: '@',
        vehicleId: '@',
        vehiclePrefix: '@',
        vehiclePlate: '@',
        driverName: '@',
        datahora: '@',
        tipoEvento: '@',
        threshold: '@',
        eventDuration: '@',
        eventLevel: '@',
        actualValue: '@',
        resolve: '='
      }
    };
  }

  class MultiVideoPlayerCtrl {
    constructor($scope, moment, Authenticator, MultiVideoService, $stateParams, DecoratedVideoPlayerService, FeaturehubJsSdk, FeatureOuService, FeatureHubConfigKeys, $uibModal, StatusVideo) {
      this.moment = moment;
      this.authenticator = Authenticator;
      this.multiVideoService = MultiVideoService;
      this.decoratedVideoPlayerService = DecoratedVideoPlayerService;
      this.FeatureOuService = FeatureOuService;
      this.isDecoratedVideoPlayerEnabled = FeaturehubJsSdk.isFeatureEnabled(FeatureHubConfigKeys.DECORATED_VIDEO_PLAYER);
      this.isDecoratedVideoPlayerNAFlagActivated = false;
      this.modalElement = null;
      this.uibModal = $uibModal;
      this.statusVideoEnum = StatusVideo;
      this.alertData = null;
      this.statusVideo = null;
      this.buildVideoParams($scope, $stateParams);
      this.initUserConfig();
    }

    buildVideoParams(scope, stateParams) {
      this.idVideo = scope.resolve ? scope.resolve.idVideo : stateParams.idVideo;
      this.snapshotId = scope.resolve ? scope.resolve.snapshotId : stateParams.snapshotId;
      this.tipoEvento = scope.resolve ? scope.resolve.tipoEvento : stateParams.tipoEvento;
      this.latitude = scope.resolve ? scope.resolve.latitude : stateParams.latitude;
      this.longitude = scope.resolve ? scope.resolve.longitude : stateParams.longitude;
      this.vehicleId = scope.resolve ? scope.resolve.vehicleId : stateParams.vehicleId;
      this.vehiclePrefix = scope.resolve ? scope.resolve.vehiclePrefix : stateParams.vehiclePrefix;
      this.vehiclePlate = scope.resolve ? scope.resolve.vehiclePlate : stateParams.vehiclePlate;
      this.driverName = scope.resolve ? scope.resolve.driverName : stateParams.driverName;
      this.datahora = this.moment(scope.resolve ? scope.resolve.datahora : stateParams.datahora).toISOString();
      this.isDialog = angular.isDefined(scope.resolve);
      this.threshold = scope.resolve ? scope.resolve.threshold : stateParams.threshold;
      this.actualValue = scope.resolve ? scope.resolve.actualValue : stateParams.actualValue;
      this.eventDuration = scope.resolve ? scope.resolve.eventDuration : stateParams.eventDuration;
      this.eventLevel = scope.resolve ? scope.resolve.eventLevel : stateParams.eventLevel;
      this.statusVideo = scope.resolve ? scope.resolve.statusVideo : stateParams.statusVideo;

      this.coordinates = {
        latitude: this.latitude,
        longitude: this.longitude
      };
      this.vehicle = {
        id: this.vehicleId,
        prefixo: this.vehiclePrefix,
        placa: this.vehiclePlate
      };
    }

    initUserConfig() {
      this.authenticator.getUser().then(user => {
        this.user = user;
        this.getDecoratedVideoPlayerConfig(user.uo.id);
        this.roleSolicitarVideo = user.permissoes.includes('VIDEO_EDITAR');
      });
    }

    getDecoratedVideoPlayerConfig(userUoId) {
      this.FeatureOuService.getDecoratedVideoPlayerConfig(userUoId).then((decoratedVideoPlayer) => {
        this.isDecoratedVideoPlayerNAFlagActivated = decoratedVideoPlayer;
        this.loadInitialData();
      }).catch((error) => {
        this.log.error('Error loading featureOu config: ', error);
      });
    }

    loadInitialData() {
      const isAlertId = this.idVideo && !this.idVideo.includes('-');

      if (isAlertId) {
        this.multiVideoService.getAlertaById(this.idVideo).then(alertData => {
          const data = alertData[0] || alertData;
          if (data && data.veiculoId) {
            this.multiVideoService.getVeiculoById(data.veiculoId).then(veiculo => {
              this.alertData = this.buildAlertDataFromResponse(data, veiculo);
              this.statusVideo = data.statusVideo;
              this.configurarPlayerMultiVideo();
            }).catch(() => {
              this.alertData = this.buildAlertDataFromResponse(data, null);
              this.statusVideo = data.statusVideo;
              this.configurarPlayerMultiVideo();
            });
          } else {
            if (data) {
              this.alertData = this.buildAlertDataFromResponse(data, null);
              this.statusVideo = data.statusVideo;
            }
            this.configurarPlayerMultiVideo();
          }
        }).catch(() => {
          this.configurarPlayerMultiVideo();
        });
      } else {
        this.configurarPlayerMultiVideo();
      }
    }

    buildAlertDataFromResponse(data, veiculo) {
      const veiculoObj = data.veiculo || veiculo || {id: data.veiculoId};
      return {
        id: data.id,
        videoId: data.videoId,
        snapshotId: data.snapshotId,
        datahora: data.datahora,
        idVeiculo: data.veiculoId,
        tipoEvento: data.tipoAlerta,
        threshold: data.limiar,
        eventDuration: data.duracao,
        actualValue: data.excesso,
        eventLevel: data.nivel,
        statusVideo: data.statusVideo,
        veiculo: veiculoObj,
        tipo: data.tipoAlerta,
        latitude: data.latitude,
        longitude: data.longitude,
        prefixo: data.prefixo || (veiculo && veiculo.prefixo),
        placa: data.placa || (veiculo && veiculo.placa) || veiculoObj.placa,
        motorista: data.motorista,
        coordinates: data.coordinates || {latitude: data.latitude, longitude: data.longitude}
      };
    }

    shouldDisplayDecoratedVideoPlayer() {
      return this.isDecoratedVideoPlayerEnabled && this.isDecoratedVideoPlayerNAFlagActivated;
    }

    configurarPlayerMultiVideo() {
      /*eslint-disable */
      this.modalElement = document.querySelector('.modal');
      const modalDialogElement = document.querySelector('.modal-dialog'),
        playerContainer = document.querySelector('#video-player-container');

      if (modalDialogElement) {
        modalDialogElement.style.width = '95vw';
        modalDialogElement.style.margin = '0px auto';
      }

      if (playerContainer) {
        this.authenticator.getUser().then(user => {
          if (user) {
            if (this.shouldDisplayDecoratedVideoPlayer()) {
              this.loadDecoratedVideoPlayer(user);
            } else {
              const playerMultiVideo = document.createElement('vfwc-dialog-event-viewer'); /*eslint-enable */

              if (this.snapshotId) {
                playerMultiVideo.snapshotId = this.snapshotId;
              } else {
                playerMultiVideo.idVideo = this.idVideo;
              }
              playerMultiVideo.dataHora = this.datahora;
              playerMultiVideo.user = user;
              playerMultiVideo.tipoEvento = this.tipoEvento;
              playerMultiVideo.coordinates = this.coordinates;
              playerMultiVideo.vehicle = this.vehicle;
              playerMultiVideo.driverName = this.driverName;
              playerMultiVideo.isDialog = this.isDialog;
              playerMultiVideo.threshold = this.threshold;
              playerMultiVideo.actualValue = this.actualValue;
              playerMultiVideo.eventDuration = this.eventDuration;
              playerMultiVideo.eventLevel = this.eventLevel;
              playerContainer.appendChild(playerMultiVideo);
              this.onWatchedVideo(playerMultiVideo);
              this.onModalClosed(playerMultiVideo);
            }
          }
        });
      }
    }

    loadDecoratedVideoPlayer(user) {
      const isSeparatedVideoScreen = true,
          hasVideo = this.idVideo && this.idVideo.includes('-');
      let props;

      if (hasVideo) {
        props = {
          idVideo: this.idVideo,
          snapshotId: this.snapshotId,
          datahora: this.datahora,
          tipoEvento: this.tipoEvento,
          latitude: this.latitude,
          longitude: this.longitude,
          vehicleId: this.vehicleId,
          vehiclePrefix: this.vehiclePrefix,
          vehiclePlate: this.vehiclePlate,
          driverName: this.driverName,
          threshold: this.threshold,
          eventDuration: this.eventDuration,
          actualValue: this.actualValue,
          eventLevel: this.eventLevel,
          user: user,
          statusVideo: 'CONCLUIDO'
        };
      } else if (this.alertData) {
        props = {
          alertaId: this.alertData.id,
          snapshotId: this.alertData.snapshotId,
          datahora: this.alertData.datahora,
          tipoEvento: this.alertData.tipoEvento,
          latitude: this.alertData.latitude,
          longitude: this.alertData.longitude,
          vehicleId: this.alertData.veiculo.id,
          vehiclePrefix: this.alertData.prefixo,
          vehiclePlate: this.alertData.placa,
          driverName: this.alertData.motorista,
          threshold: this.alertData.threshold,
          eventDuration: this.alertData.eventDuration,
          actualValue: this.alertData.actualValue,
          eventLevel: this.alertData.eventLevel,
          user: user,
          statusVideo: this.alertData.statusVideo,
          coordinates: this.alertData.coordinates,
          requestVideo: (onRequestCompleted) => this.abrirModalRequisicaoVideo(this.alertData, onRequestCompleted),
          requestVideoPermission: this.roleSolicitarVideo
        };

        if (this.alertData.videoId) {
          props.idVideo = this.alertData.videoId;
        }
      } else {
        props = {
          snapshotId: this.snapshotId,
          datahora: this.datahora,
          tipoEvento: this.tipoEvento,
          latitude: this.latitude,
          longitude: this.longitude,
          vehicleId: this.vehicleId,
          vehiclePrefix: this.vehiclePrefix,
          vehiclePlate: this.vehiclePlate,
          driverName: this.driverName,
          threshold: this.threshold,
          eventDuration: this.eventDuration,
          actualValue: this.actualValue,
          eventLevel: this.eventLevel,
          user: user,
          statusVideo: this.statusVideo
        };
      }

      this.decoratedVideoPlayerService.loadDecoratedVideoPlayer(props, isSeparatedVideoScreen);
    }

    onWatchedVideo(element) {
      element.addEventListener('markWatched', (event) => {
        const video = event.detail;
        this.multiVideoService.updateVideo(video);
      });
    }

    onModalClosed(element) {
      element.addEventListener('modalClosedEvent', (event) => {
        if (this.modalElement && event.detail.isModalClosed) {
          this.modalElement.remove();
        }
      });
    }

    abrirModalRequisicaoVideo(alerta, onRequestCompleted) {
      if (alerta && !alerta.user) {
        alerta.user = this.user;
      }

      this.uibModal.open({
        component: 'modalRequisicaoVideo',
        backdrop: 'static',
        resolve: {
          alerta: () => alerta,
          onRequestCompleted: () => onRequestCompleted
        }
      }).result.then((videoId) => {
        if (alerta) {
          alerta.statusVideo = 'CADASTRADO';
          alerta.videoId = videoId;
        }
      });
    }
  }

  MultiVideoPlayerCtrl.$inject = ['$scope', 'moment', 'Authenticator', 'MultiVideoService', '$stateParams', 'DecoratedVideoPlayerService', 'FeaturehubJsSdk', 'FeatureOuService', 'FeatureHubConfigKeys', '$uibModal', 'StatusVideo'];

  angular
    .module('videoPlayer')
    .controller('MultiVideoPlayerCtrl', MultiVideoPlayerCtrl)
    .directive('multiVideoPlayer', MultiVideoPlayer);
}());
